import { createSlice } from '@reduxjs/toolkit';
import { resetOnLogout } from '~/reducers/common-actions';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '~/store';
import {
    defaultSelectedMapDepotStopState,
    type SelectedMapDepotStopState
} from './types';

export const selectedMapDepotStopSlice = createSlice({
    name: 'selectedMapDepotStop',
    initialState: defaultSelectedMapDepotStopState,
    reducers: {
        setSelectedMapDepotStop: (
            state: SelectedMapDepotStopState,
            action: PayloadAction<string>
        ) => {
            const isSameDepotStop = state === action.payload;
            return isSameDepotStop ? null : action.payload;
        },
        resetSelectedMapDepotStop: (): SelectedMapDepotStopState => {
            return defaultSelectedMapDepotStopState;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetOnLogout, () => {
            return defaultSelectedMapDepotStopState;
        });
    }
});

export const { setSelectedMapDepotStop, resetSelectedMapDepotStop } =
    selectedMapDepotStopSlice.actions;

export const selectSelectedMapDepotStop = (
    state: RootState
): SelectedMapDepotStopState => state.selectedMapDepotStop;

export default selectedMapDepotStopSlice.reducer;
